<template>
  <div id="AppointmentTimezoneInfoModal" class="brand-text">
    <button
      type="button"
      class="close-button brand-highlight-1"
      aria-label="Close appointment timezone information"
      @click="closeModal"
    >
      <i class="fas fa-times"></i>
    </button>
    <div class="timezone-modal-content">
      <h3 class="timezone-modal-title">Appointment timezone</h3>
      <p class="timezone-modal-description">
        Times in your bookings are shown in your local timezone.
      </p>

      <div class="timezone-modal-section">
        <div class="timezone-modal-label">Your local timezone</div>
        <div class="timezone-modal-zone">{{ timezoneInfo.localZone }}</div>
        <div class="timezone-modal-time brand-highlight-3">
          {{ timezoneInfo.localTime }}
        </div>
      </div>

      <div class="timezone-modal-section">
        <div class="timezone-modal-label">Appointment time</div>
        <div class="timezone-modal-zone">
          {{ timezoneInfo.appointmentZone }}
        </div>
        <div class="timezone-modal-time brand-highlight-3">
          {{ timezoneInfo.appointmentTime }}
        </div>
      </div>

      <b-button
        variant="continue"
        class="timezone-modal-button"
        @click="closeModal"
      >
        Close
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentTimezoneInfoModal",
  props: {
    timezoneInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("appointment_timezone_modal");
    },
  },
};
</script>

<style lang="less">
#appointment_timezone_modal___BV_modal_outer_ {
  z-index: 1000000 !important;
}

#AppointmentTimezoneInfoModal {
  position: relative;
  padding: 28px 24px 24px;

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    border: 0;
    background: transparent;
    cursor: pointer;
    font-size: 2rem;
    line-height: 1;
  }

  .timezone-modal-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .timezone-modal-title {
    margin: 0 32px 8px 0;
    font-family: "DMSans Bold";
    font-size: 2.2rem;
    line-height: 2.8rem;
  }

  .timezone-modal-description,
  .timezone-modal-zone {
    font-family: "DMSans";
    font-size: 1.5rem;
    line-height: 2.1rem;
  }

  .timezone-modal-description {
    margin-bottom: 4px;
  }

  .timezone-modal-section {
    margin-top: 18px;
  }

  .timezone-modal-label,
  .timezone-modal-time {
    font-family: "DMSans Bold";
  }

  .timezone-modal-label {
    font-size: 1.5rem;
    line-height: 2.1rem;
    margin-bottom: 4px;
  }

  .timezone-modal-time {
    font-size: 1.7rem;
    line-height: 2.3rem;
    margin-top: 4px;
  }

  .timezone-modal-button {
    margin-top: 24px;
    min-height: 44px;
    width: 100%;
  }
}
</style>
